import React from "react";

import SidebarTransition from "@Shared/Components/MacroSidebar/SidebarTransition";
import Pages from "@Shared/Components/LinkSidebar/Pages";

const PagesSidebarTransition = ({ isOpen, setIsOpen, value, onChange }) => (
  <SidebarTransition
    isOpen={isOpen}
    position="right"
    close={() => setIsOpen(false)}
    width={400}
    containerStyles={{ top: "75px" }}
    additionalStyle={{
      padding: "0 13px 0 0",
    }}
    shouldHideScrollbar={!isOpen}
  >
    <Pages value={value} setValue={onChange} />
  </SidebarTransition>
);

export default PagesSidebarTransition;
